import update from "immutability-helper";
import uniqueId from "lodash/uniqueId";
import * as actionTypes from "../actionTypes";

import { CreateVideoSequenceTrackWithM3U8Content, CreateTrack } from "../../util/EditUtil";
import { log } from "console";

import { segmentText } from '../../util/videoSubtitle'
/**
 *  轨道类型
 *  1 ===> 文字轨道
 *  2 ===> 贴纸轨道
 *  3 ===> 滤镜轨道
 *  4 ===> 特效轨道
 *  5 ===> 画中画轨道
 *  6 ===> 音频轨道
 */

const defaultState = {
    editWindow: {
        target: null,
        isShow: false,
        width: 0,
        height: 0,
        left: 0,
        top: 0,
        scale: {
            mX: 1,
            mY: 1
        },
        originWidth: 0,
        originHeight: 0,
        rotation: 0
    },
    isDragActive: false,
    videoSubtitleList: [

    ],//用来存放视频拆分后的数据
    trackListScrollTop: 0,
    trackListScrollLeft: 0,
    currentWindowIndex: 0,
    editWindowHeadListIsUpdate: false,
    mainTrackGroup: null,
    backgroundTrack: null,
    editorManager: null,
    audioManager: null,
    currentDragItem: null,
    isShowMaskShape: false,
    canvasWidth: null,
    canvasHeight: null,
    canvasBackGroundColor: "#000000",
    space: 10,
    longScale: 10,
    currentTime: 0,
    isMoveTimeLine: true,
    isUpdate: false,
    pathwayRightListPosition: null,
    currentFilterEffectDragItem: null,
    startCallbackId: -3,
    playOrPause: false,
    timerShaftWidth: 6000,
    maxDuration: 0,
    groupSourceList: [],
    splitWaitStatus: false,//是否显示拆条加载状态
    currentRation: {
        name: "4:3",
        value: [720, 540],
        horizontal: true
    },
    ratioArr: {
        1901: {
            name: "9:16",
            value: [540, 960],
            horizontal: false
        },
        1902: {
            name: "3:4",
            value: [540, 720],
            horizontal: false
        },
        1903: {
            name: "1:1",
            value: [720, 720],
            horizontal: false
        },
        1904: {
            name: "4:3",
            value: [720, 540],
            horizontal: false
        },
        1905: {
            name: "4:3",
            value: [720, 540],
            horizontal: true
        },
    },
    allMediaBeforeDuration: {

    },//原有视频长度，实现拖动轨道动态切换图片展示间隔
    currentSpeed: {
        name: "1x",
        value: 1,
        horizontal: false
    },
    speedArr: [
        {
            name: "0.5x",
            value: 0.5,
            horizontal: false
        }, {
            name: "1x",
            value: 1,
            horizontal: false
        }, {
            name: "1.5x",
            value: 1.5,
            horizontal: false
        }, {
            name: "2x",
            value: 2,
            horizontal: false
        }, {
            name: "3x",
            value: 3,
            horizontal: false
        },
    ],
    proportionIndex: sessionStorage.getItem('proportionIndex') || '-1',//设置尺寸
    proportionList: { //作品比例
        '0': {
            value: [720, 540],
            name: '4:3',
        },
        '1': {
            value: [540, 720],
            name: '3:4'
        },
        '2': {
            value: [640, 640],
            name: '1:1'
        },
    },
    trackDrag: {
        left: 0,
        top: 0,
        isShow: false,
        data: null,
    },
    filter_effect_group: [],
    isFilterGroup: false,
    groupList: [],
    testUseVideoOrImageFileArr: [
        {
            url: "//vei-oss1.atvideo.cc/2020/12/09/16/59/53df5e4280064cbaba0d7122c91a081c_tplv-k3u1fbpfcp-zoom-1.jpg",
            fileName: "测试图片.png"
        },
        {
            url: "//vei-oss1.atvideo.cc/2020/12/09/16/58/transcode-RSV308959549820256615-00002_VQMC3Ep41X.mp4",
            fileName: "测试视频1.mp4"
        },
        {
            url: "//vei-oss1.atvideo.cc/2020/12/01/14/18/03000801005EB91C56541EA003E88046533112-1725-497B-B229-D15542DA5BB3.mp4",
            fileName: "声音测试视频1.mp4"
        },

    ]
};

export type IDefaultState = typeof defaultState;

const Change = (state, action) => {
    let { groupList } = state;
    groupList[action.payload.id].BoundingClientRect = action.payload.BoundingClientRect;
    return Object.assign({}, { ...state }, {
        groupList
    });
}

const ChangeFilterEffect = (state, action) => {
    let { filter_effect_group } = state;
    filter_effect_group[action.payload.id].BoundingClientRect = action.payload.BoundingClientRect;
    return Object.assign({}, { ...state }, {
        filter_effect_group
    });
}

const ChangeCurrentTrack = (state: IDefaultState, action) => {
    if (!state.groupList[action.payload.id]) {
        return state;
    }

    return update(state, {
        groupList: {
            [action.payload.id]: {
                $set: {
                    ...state.groupList[action.payload.id],
                    currentTrack: action.payload.status
                }
            }
        }
    });
}

const ChangeFilterEffectCurrentTrack = (state: IDefaultState, action) => {
    if (!state.filter_effect_group[action.payload.id]) {
        return state;
    }

    return update(state, {
        filter_effect_group: {
            [action.payload.id]: {
                $set: {
                    ...state.filter_effect_group[action.payload.id],
                    currentTrack: action.payload.status
                }
            }
        }
    });
}


const appendGroupSourceItem = (state: IDefaultState, action) => {
    let { payload } = action

    console.log("append group source item", payload.data)
    return update(state, {
        groupSourceList: {
            $push: payload.data,
        }
    })
}

//工具方法
const forEach = (list: any[], callback: Function) => {
    let i = 0,
        len = list.length;
    for (; i < len; i++) {
        callback(list[i], i);
    }
}


const getEffect = (id: string, effects: any) => {
    for (let i = 0; i < effects.length; i++) {
        if (id == effects[i]["trackId"]) {
            return effects[i];
        }
    }
    return null;
}


const addEffectToMainTrack  = (mainCompositeTrack: any, data: any, isFilter: boolean): any => {
    let effectDuration = data.duration, // 特效时长
    inPoint = data.startTime, // 特效起始点
    SXResourceType = window["SXResourceType"],
    SXResource = window["SXResource"],
    SXEffectTimeFollowType = window["SXEffectTimeFollowType"];
    let effectInfo = null;

    let track = mainCompositeTrack,
        effect = null;

    if (isFilter) {
        let source = new SXResource(SXResourceType.kFilter, data.effectPath);
        effect = track.addFilter(source, 0, -1)
    } else {
        let source = new SXResource(SXResourceType.kVideoEffect, data.effectPath);
        effect = track.addVideoEffect(source, 0, -1)
    }

    effect.setStartTime(inPoint);
    effect.setDuration(effectDuration);
    effect.setFollowType(SXEffectTimeFollowType.kDisplayTime);

    console.log("effectDuration", inPoint, effectDuration, effectDuration);

    effectInfo = {
        trackId: mainCompositeTrack.getTrackId(),
        track: track,
        effect: effect,
        effectId: effect.getEffectId(),

    };
    return effectInfo;
}

// 添加特效，滤镜轨道组
const Add_Filter_Effect_Group = (state: IDefaultState, action) => {
    let { payload: { data, mainTrackList }, isFirst = false } = action,
        { editorManager } = state,
        id = uniqueId("filter_or_text"),
        effectInfo = null;

    let {mainCompositeTrack} = data;

    console.log("action", action);
        
    switch (data.type) {
        case 3:
            effectInfo = addEffectToMainTrack(mainCompositeTrack, data, true);
            console.log("遍历添加滤镜!");
            break;

        case 4:
            effectInfo = addEffectToMainTrack(mainCompositeTrack, data, false);
            console.log("遍历添加视频特效!");
            break;
    }

    editorManager.draw(true, false, -1);

    let duration = data.duration || 4,
        appendData = {
            id,
            type: data.type,
            BoundingClientRect: null,
            currentTrack: false,
            isShowBottomLine: false,
            isShowTopLine: false,
            trackList: [
                {
                    id: uniqueId("gdr"),
                    pid: id,
                    type: data.type,
                    startTime: data.startTime,
                    effectPath: data.effectPath,
                    text: data.text,
                    effectInfo: effectInfo,
                    duration,
                }
            ]
        };


    console.log("Add_Filter_Effect_Group", appendData)
    if (isFirst) {
        return update(state, {
            filter_effect_group: {
                $unshift: [appendData]
            }
        });
    }

    return update(state, {
        filter_effect_group: {
            $push: [appendData]
        }
    });
}



const AddGroup = (state: IDefaultState, action) => {
    let { payload: { data }, isFirst = false } = action,
        { editorManager, canvasWidth, canvasHeight, groupList } = state,
        id = uniqueId("track-group"),
        index = groupList.length;
    let {
        sxTrack, textInfoObj, groupSource, videoDelegate
    } = data.track;

    if (index !== 0) {
        if (isFirst) {
            index++;
        } else {
            index--;
        }
    } else {
        index = 1;
    }
    let sxTrackGroup = editorManager.addGroupAtIndex(index);
    let duration = data.duration || 10;

    sxTrackGroup.addTrack(sxTrack, data.startTime);
    sxTrack.setDuration(duration);


    if (data.type !== 6) {
        sxTrack.setPosition(Math.round(canvasWidth / 2), Math.round(canvasHeight / 2));

        // @NOTE 为什么这里的局部变量要用大写？？？
        // let MAX_PIX = Math.max(sxTrack.getHeight(), sxTrack.getWidth());
        // let LONG_SIZE = Math.max(canvasWidth, canvasHeight);

        if (data.type === 5) {
            let widthRatio = canvasWidth / sxTrack.getWidth();
            let heightRatio = canvasHeight / sxTrack.getHeight();
            let ratio = Math.min(widthRatio, heightRatio);
            sxTrack.setScale(ratio * 0.8, ratio * 0.8)
        } else {
            sxTrack.setScale(0.4, 0.4)
        }
    }



    let appendData = {
        id,
        type: data.type,
        BoundingClientRect: null,
        currentTrack: false,
        isShowBottomLine: false,
        isShowTopLine: false,
        sxTrackGroup,
        trackList: [
            {
                id: uniqueId("gdr"),
                trackId: sxTrack.getTrackId(),
                pid: id,
                type: data.type,
                startTime: data.startTime,
                videoDelegate: videoDelegate,
                duration,
                text: data.text,
                scale: data.type !== 6 ? sxTrack.getScale() : 1,
                sxTrack,
                rotation: 0,
                resourcesPath: data.effectPath || "",
                shotUrl: data.shotUrl
            }
        ]
    };


    if (textInfoObj["content"]) {
        appendData.trackList[0]["textInfoObj"] = textInfoObj;
    }

    if (data.currentDrag.type === 5 && Number(data.currentDrag.video_fps) === 0) {
        appendData.trackList[0].shotUrl = data.currentDrag.url
    }

    let toUpdate = {};

    if (sxTrackGroup && sxTrack) {
        if (isFirst) {
            toUpdate["groupList"] = {
                $unshift: [appendData]
            }
        } else {
            toUpdate["groupList"] = {
                $push: [appendData]
            }
        }

        if (groupSource) {
            toUpdate["groupSourceList"] = {
                $push: [groupSource]
            }
        }
        toUpdate['allMediaBeforeDuration'] = {
            [appendData.trackList[0]['id']]: {
                $set: duration
            }
        }
        return update(state, toUpdate);
    }

    return state;
}

const insertNewTrackToGroup = (state: IDefaultState, action) => {
    let { payload: { data } } = action,
        {
            editorManager, canvasWidth, canvasHeight, groupList
        } = state,
        currentGroup = groupList[data.group],
        duration = data.duration || 10;
    let { currentDrag } = data;

    let track = null;

    if (data.track) {
        track = data.track;
    } else {
        data.editorManager = editorManager;
        data.currentDrag = currentDrag;
        track = CreateTrack(data);
    }

    let { sxTrack, textInfoObj, groupSource } = track;

    //音频轨道没有设置positon功能
    if (data.type !== 6) {
        sxTrack.setPosition(Math.round(canvasWidth / 2), Math.round(canvasHeight / 2));
        // let MAX_PIX = Math.max(sxTrack.getHeight(), sxTrack.getWidth())
        // let LONG_SIZE = Math.max(canvasWidth, canvasHeight);

        if (data.type === 5) {
            let widthRatio = canvasWidth / sxTrack.getWidth();
            let heightRatio = canvasHeight / sxTrack.getHeight();
            let ratio = Math.min(widthRatio, heightRatio);
            sxTrack.setScale(ratio * 0.8, ratio * 0.8)

        } else {
            sxTrack.setScale(0.4, 0.4)

        }

    }
    currentGroup["sxTrackGroup"].addTrack(sxTrack, data.startTime);
    sxTrack.setDuration(duration);
    let appendData = {
        id: uniqueId("gdr"),
        pid: currentGroup.id,
        trackId: sxTrack.getTrackId(),
        type: data.type,
        startTime: data.startTime,
        text: data.text,
        rotation: 0,
        duration,
        sxTrack,
        scale: data.type !== 6 ? sxTrack.getScale() : 1,
        resourcesPath: data.effectPath || "",
        shotUrl: data.currentDrag.shots_url

    };
    if (textInfoObj["content"]) {
        appendData["textInfoObj"] = textInfoObj;
    }

    if (data.currentDrag.type === 5 && Number(data.currentDrag.video_fps) === 0) {
        appendData.shotUrl = data.currentDrag.url
    }
    let toUpdate = {};

    toUpdate["groupList"] = {
        [data.group]: {
            trackList: {
                $push: [appendData]
            }
        }
    }

    if (groupSource) {
        toUpdate["groupSourceList"] = {
            $push: [groupSource]
        }
    }
    toUpdate['allMediaBeforeDuration'] = {
        [appendData['id']]: {
            $set: duration
        }
    }

    return update(state, toUpdate);
}

const insert_Filter_Effect_TrackToGroup = (state: IDefaultState, action) => {


    let { payload: { data }, isFirst = false } = action,
        { editorManager } = state,
        effectInfo = null;
    let { filter_effect_group, mainTrackGroup } = state;
    let currentGroup = filter_effect_group[data.group];
    let { mainTrackList, mainCompositeTrack } = data;

    console.log("insert_filter_effect_track_to_group", currentGroup, data);
    switch (data.type) {
        case 3:
            effectInfo = addEffectToMainTrack(mainCompositeTrack, data, true);
            console.log("遍历添加滤镜!");
            break;

        case 4:
            effectInfo = addEffectToMainTrack(mainCompositeTrack, data, false);
            console.log("遍历添加视频特效!");
            break;
    }

    editorManager.draw(true, false, -1);

    let duration = data.duration || 4,
        appendData = {
            id: uniqueId("gdr"),
            pid: currentGroup.id,
            type: data.type,
            startTime: data.startTime,
            effectPath: data.effectPath,
            text: data.text,
            effectInfo: effectInfo,
            duration,
        };

    console.log("insert_Filter_Effect_TrackToGroup", appendData)
    return update(state, {
        filter_effect_group: {
            [data.group]: {
                trackList: {
                    $push: [appendData]
                }
            }
        }
    });
}

const ChangeCurrentDragItem = (state: IDefaultState, action) => {

    let { payload } = action;
    let { groupList } = state;
    let newList = null;
    let videoSubtitleList = Object.assign([], state.videoSubtitleList)

    if (payload) {
        newList = groupList.map((group) => {
            if (group.id === payload.pid) {
                group.trackList = group.trackList.map((track) => {
                    if (track.id === payload.id) {
                        track = payload;
                    }
                    return track
                });
            }
            return group;
        });
        //当group文本改变时，同时改变字幕数组
        videoSubtitleList.forEach((v, i) => {
            v.forEach((m, index) => {
                if (m.trackId_text === payload.id) {
                    m.Text = payload.textInfoObj.content
                }
            })
        })

    }
    let newState = update(state, {
        currentDragItem: { $set: payload }
    });

    if (newState.currentFilterEffectDragItem) {
        newState.currentFilterEffectDragItem = null;
    }

    if (newList) {
        return update(newState, {
            groupList: { $set: newList },
            videoSubtitleList: { $set: videoSubtitleList }
        });
    } else {
        return newState;
    }
}

const ChangeFilterEffectCurrentDragItem = (state: IDefaultState, action) => {
    let { payload } = action;
    let { filter_effect_group } = state;
    let newList = null;
    if (payload) {
        newList = filter_effect_group.map((group) => {
            if (group.id === payload.pid) {
                let trakList = group.trackList.map((track) => {
                    if (track.id === payload.id) {
                        track = payload;
                    }
                    return track
                });
                group.trackList = trakList;
            }
            return group;
        });

    }

    let newState = update(state, {
        currentFilterEffectDragItem: { $set: payload }
    });

    if (newState.currentDragItem) {
        newState.currentDragItem = null;
    }

    if (newList) {
        return update(newState, {
            filter_effect_group: { $set: newList }
        });
    } else {
        return newState;
    }
}

const updateCurrentDragItem = (state: IDefaultState, action) => {
    let { payload } = action;
    let { currentFilterEffectDragItem } = state;

    if (currentFilterEffectDragItem) {
        currentFilterEffectDragItem = null;
    }

    return update(state, {
        currentDragItem: { $set: payload }
    });
}


const changeInputValue = (state: IDefaultState, action) => {
    let { payload } = action;
    let subtitleList = state.videoSubtitleList
    let { data, paragraphIndex, subtitleIndex, subTitleInfo } = payload
    let track;
    let newGroupList = Object.assign([], state.groupList)
    //根据trackId找出对应的素材，并执行绘制操作

    newGroupList.forEach(v => {
        v.trackList.forEach(item => {
            if (item.id === subTitleInfo.trackId_text) {
                track = item
                //同时改变groupList中的值
                item.textInfoObj.content = data
            }
        })
    })
    var nowrapText = data
    data = segmentText(data.replace(/\n/g, ""), 20)
    track.sxTrack.setContent(data)
    state.editorManager.draw(true, false, -1)
    //根据索引改变页面显示的内容
    subtitleList[paragraphIndex][subtitleIndex]['Text'] = nowrapText
    return update(state, {
        videoSubtitleList: { $set: Object.assign([], subtitleList) },
        groupList: { $set: newGroupList }
    });
}
const changeVideoSubtitleText = (state: IDefaultState, action) => {
    console.log(action, 'sssss')
}
//删除字幕同时删除文字素材和视频素材
const deleteSubtitle = (state: IDefaultState, action) => {

    let { payload } = action;
    let videoSubtitleList = Object.assign([], state.videoSubtitleList)
    let { paragraphIndex, subtitleIndex, subTitleInfo } = payload
    videoSubtitleList[paragraphIndex].splice(subtitleIndex, 1)
    //删除文字轨道
    let track = null
    let testGroup = Object.assign([], state.groupList)
    testGroup.forEach(v => {
        v.trackList.forEach((item, index) => {
            if (item.id === subTitleInfo.trackId_text || item.id === subTitleInfo.trackId_main) {
                track = item
                state.editorManager.getGroup(track.sxTrack.getGroupId()).removeTrack(track.trackId);
                state.editorManager.deleteTrack(track.trackId)
                v.trackList.splice(index, 1)
            }
        })
    })

    return update(state, {
        groupList: { $set: testGroup },

        videoSubtitleList: { $set: videoSubtitleList }
    });
}
const Update = (state: IDefaultState, action) => {
    let { payload } = action;
    return update(state, {
        isUpdate: { $set: payload.status }
    });
}

const ChangeIsMoveTimeLineStatus = (state: IDefaultState, action) => {
    let { payload } = action;
    return update(state, {
        isMoveTimeLine: { $set: payload.status }
    });
}

const AppendTrackToGroup = (state: IDefaultState, action) => {
    let { payload: { index, startTime } } = action,
        le = state.groupList.length,
        currentDragItem = state.currentDragItem,
        data = null,
        GroupIndex = null,
        currentDrageIndex = null,
        editorManager = state.editorManager,
        pid = state.groupList[index].id;

    for (let i = 0; i < le; i++) {
        let DragItem = state.groupList[i];
        let le = DragItem.trackList.length;
        let trackList = DragItem.trackList;
        DragItem.isShowBottomLine = false;
        DragItem.currentTrack = false;
        for (let j = 0; j < le; j++) {
            if (trackList[j].id === currentDragItem.id) {
                GroupIndex = i;
                currentDrageIndex = j;
                data = DragItem;
            }
        }
    }
    state.currentDragItem = null;
    let sxTrack = currentDragItem.sxTrack.clone(),
        oldTrackId = currentDragItem.sxTrack.getTrackId(),
        deleteGroup = state.groupList[GroupIndex],
        appendData = {
            ...currentDragItem,
            startTime,
            pid,
            sxTrack,
            id: uniqueId("drag"),
            type: currentDragItem.type,
            duration: currentDragItem.duration,
            text: currentDragItem.text,
        };
    if (data.trackList.length > 1) {
        //删除轨道 
        editorManager.deleteTrack(oldTrackId);

        let newState = update(state, {
            groupList: {
                [GroupIndex]: {
                    trackList: {
                        $splice: [[currentDrageIndex, 1]]
                    }
                }
            },
            //             allMediaBeforeDuration:{
            //  [currentDragItem.id]:{
            //                     $set:state.allMediaBeforeDuration[currentDragItem['id']] 
            //                 }
            //             }

        });
        //添加轨道
        newState.groupList[index].sxTrackGroup.addTrack(sxTrack, appendData.startTime);

        return update(newState, {
            groupList: {
                [index]: {
                    trackList: {
                        $push: [appendData]
                    }
                }
            },

        });
    } else {

        state.editorManager.deleteGroup(deleteGroup.sxTrackGroup.getGroupId());
        let newState = update(state, {
            groupList: {
                $splice: [[GroupIndex, 1]]
            },
            allMediaBeforeDuration: {
                [appendData.id]: {
                    $set: currentDragItem.duration
                }
            }
        });
        if (index > GroupIndex) {
            index--;
        }
        newState.groupList[index].sxTrackGroup.addTrack(sxTrack, appendData.startTime);
        return update(newState, {
            groupList: {
                [index]: {
                    trackList: {
                        $push: [appendData]
                    }
                }
            },

        });
    }
}

const ChangeDragStartTime = (state: IDefaultState, action) => {
    let { payload } = action,
        { Drag: { pid, id }, startTime } = payload,
        le = state.groupList.length;
    for (let i = 0; i < le; i++) {
        let DragItem = state.groupList[i];
        let le = DragItem.trackList.length;
        if (DragItem.id === pid) {
            for (let j = 0; j < le; j++) {
                const currentTrackItem = DragItem.trackList[j],
                    currentTrack = currentTrackItem.sxTrack;

                if (currentTrackItem.id === id) {
                    const offset = currentTrack.getOffsetTime();
                    if (offset !== 0) {
                        currentTrack.setStartTime(startTime - offset);
                    } else {
                        currentTrack.setStartTime(startTime);
                    }

                    return update(state, {
                        groupList: {
                            [i]: {
                                trackList: {
                                    [j]: { startTime: { $set: startTime } }
                                }
                            }
                        }
                    });
                }
            }
        }
    }
}

// 修改 滤镜特效 起始时间
const ChangeFilterEffectDragStartTime = (state: IDefaultState, action) => {
    let { payload } = action,
        { Drag: { pid, id }, startTime, mainCompositeTrack } = payload,
        le = state.filter_effect_group.length;

    console.log("ChangeFilterEffectDragStartTime", payload);
    for (let i = 0; i < le; i++) {
        let DragItem = state.filter_effect_group[i];
        let le = DragItem.trackList.length;
        if (DragItem.id === pid) {
            for (let j = 0; j < le; j++) {
                if (DragItem.trackList[j].id === id) {
                    let currentTrack = DragItem.trackList[j];
        
                    currentTrack.startTime = startTime;
                    currentTrack.effectInfo.effect.setStartTime(currentTrack.startTime)
                    return update(state, {
                        currentFilterEffectDragItem: { $set: currentTrack },
                    });
                }
            }
        }
    }
}

const ChangeMaxDuration = (state: IDefaultState) => {
    let { editorManager } = state;
    if (editorManager) {
        let duration = editorManager.getContextMaxTime(false);//true ,排除音频时长 ，false不排除
        editorManager.setDuration(duration);
        duration = editorManager.getDuration();

        return update(state, {
            maxDuration: { $set: duration }
        });
    }

    return state;
}

const ChangeCurrentTime = (state: IDefaultState, action) => {
    let { payload } = action;
    let { editorManager } = state;

    // console.log("change current time", payload);
    if (!payload.status) {
        editorManager.seek(payload.currentTime);
        editorManager.draw(true, false, -1);
    }

    return update(state, {
        currentTime: { $set: payload.currentTime }
    });
}

const ChangeDragDuration = (state: IDefaultState, action) => {
    let { payload } = action;
    let { Drag: { pid, id }, duration } = payload;
    let le = state.groupList.length;
    for (let i = 0; i < le; i++) {
        let DragItem = state.groupList[i];
        let le = DragItem.trackList.length;
        if (DragItem.id === pid) {
            for (let j = 0; j < le; j++) {
                if (DragItem.trackList[j].id === id) {
                    DragItem.trackList[j].sxTrack.setDuration(duration);
                    return update(state, {
                        groupList: {
                            [i]: {
                                trackList: {
                                    [j]: { duration: { $set: duration } }
                                }
                            }
                        }
                    });
                }
            }
        }
    }
}

const ChangeFilterEffectDragDuration = (state: IDefaultState, action) => {

    let { payload } = action;
    let { Drag: { pid, id }, duration} = payload;
    let le = state.filter_effect_group.length;
    
    console.log("ChangeFilterEffectDragDuration", action);

    for (let i = 0; i < le; i++) {
        let DragItem = state.filter_effect_group[i];
        let le = DragItem.trackList.length;
        if (DragItem.id === pid) {
            for (let j = 0; j < le; j++) {
                if (DragItem.trackList[j].id === id) {
                    let currentTrack = DragItem.trackList[j];
                    currentTrack.duration = duration;
                    currentTrack.effectInfo.effect.setDuration(currentTrack.duration);

                    return update(state, {
                        currentFilterEffectDragItem: { $set: currentTrack },
                    });
                }
            }
        }
    }
}

const ChangeGroupToBottomboundary = (state: IDefaultState, action) => {
    let { payload: { startTime } } = action;
    let { editorManager } = state;
    let le = state.groupList.length;
    let currentDragItem = state.currentDragItem;
    let data = null;
    let index = null;
    let currentDrageIndex = null;
    for (let i = 0; i < le; i++) {
        let DragItem = state.groupList[i];
        let le = DragItem.trackList.length;
        let trackList = DragItem.trackList;
        DragItem.isShowBottomLine = false;
        for (let j = 0; j < le; j++) {
            if (trackList[j].id === currentDragItem.id) {
                index = i;
                currentDrageIndex = j;
                data = DragItem;
                trackList[j].startTime = startTime;
                let id = DragItem.trackList[j].sxTrack.trackId();
                DragItem.sxTrackGroup.offsetTrack(id, startTime);
            }
        }
    }


    if (data.trackList.length > 1) {
        let deleteArr = data.trackList.splice(currentDrageIndex, 1);
        let track = currentDragItem.sxTrack.clone();
        let deleteItem = deleteArr[0];
        editorManager.removeTrack(deleteItem.sxTrack.trackId(), true);
        let newData = {
            type: deleteItem.type,
            duration: deleteItem.duration,
            text: deleteItem.text,
            effectPath: deleteItem.resourcesPath || "",
            rotation: deleteItem.rotation,
            startTime,
        };

        let id = uniqueId("afa");
        let duration = data.duration || 10;

        let textInfoObj = null;
        switch (newData.type) {
            case 1:
                //文字轨道
                textInfoObj = currentDragItem.textInfoObj;
                break;

            case 2:
                //贴纸轨道
                break;

            case 5:
                // 画中画
                break;
            case 6:
                // 音频
                break;

            default:
                track = null;
                break;
        }

        let trackGroup = editorManager.insertNewGroupAt(index);
        trackGroup.addTrack(track, newData.startTime);
        let scale = track.scale();


        let appendData = {
            id,
            type: newData.type,
            BoundingClientRect: null,
            currentTrack: false,
            isShowBottomLine: false,
            isShowTopLine: false,
            sxTrackGroup: trackGroup,
            trackList: [
                {
                    id: uniqueId("gdr"),
                    pid: id,
                    type: newData.type,
                    startTime: newData.startTime,
                    duration,
                    text: newData.text,
                    scale,
                    sxTrack: track,
                    rotation: newData.rotation || 0,
                    resourcesPath: newData.effectPath || "",
                    textInfoObj
                }
            ]
        };
        state.currentDragItem = null;

        return update(state, {
            groupList: {
                $push: [appendData]
            }
        });
    }


    let newState = update(state, {
        groupList: {
            $splice: [[index, 1]]
        }
    });

    state.currentDragItem = null;

    return update(newState, {
        groupList: {
            $push: [data]
        }
    });
}

const insertionNewFilterEffectGroup = (state: IDefaultState, action) => {
    let { payload: { index: GroupIndex, startTime } } = action;
    let le = state.filter_effect_group.length;
    let currentDragItem = state.currentFilterEffectDragItem;
    let data = null;
    let index = null;
    let currentDrageIndex = null;
    for (let i = 0; i < le; i++) {
        let DragItem = state.filter_effect_group[i];
        let le = DragItem.trackList.length;
        let trackList = DragItem.trackList;
        DragItem.isShowBottomLine = false;
        for (let j = 0; j < le; j++) {
            if (trackList[j] && currentDragItem) {
                if (trackList[j].id === currentDragItem.id) {
                    index = i;
                    currentDrageIndex = j;
                    data = DragItem;
                }
            }

        }
    }
    let id = uniqueId("swf");
    let appendData = {
        id,
        type: currentDragItem.type,
        BoundingClientRect: null,
        currentTrack: false,
        isShowBottomLine: false,
        isShowTopLine: false,
        trackList: [
            {
                id: uniqueId("fa"),
                pid: id,
                type: currentDragItem.type,
                startTime: startTime,
                duration: currentDragItem.duration,
                text: currentDragItem.text
            }
        ]
    };



    state.currentFilterEffectDragItem = null;

    if (data.trackList.length > 1) {
        data.trackList.splice(currentDrageIndex, 1);
        return update(state, {
            filter_effect_group: {
                $splice: [[GroupIndex + 1, 0, appendData]]
            }
        });
    } else {
        if (index === GroupIndex || (GroupIndex + 1) === index) {
            return state;
        } else {
            let newState = update(state, {
                filter_effect_group: {
                    $splice: [[GroupIndex + 1, 0, appendData]]
                }
            });
            if (index > GroupIndex) {
                index++;
            }
            return update(newState, {
                filter_effect_group: {
                    $splice: [[index, 1]]
                }
            });
        }
    }
}

const insertionNewGroup = (state: IDefaultState, action) => {
    let { payload: { index: GroupIndex, startTime } } = action;
    let { editorManager } = state;
    let le = state.groupList.length;
    let currentDragItem = state.currentDragItem;
    let data = null;
    let index = null;
    let currentDrageIndex = null;
    for (let i = 0; i < le; i++) {
        let DragItem = state.groupList[i];
        let le = DragItem.trackList.length;
        let trackList = DragItem.trackList;
        DragItem.isShowBottomLine = false;
        for (let j = 0; j < le; j++) {
            if (trackList[j] && currentDragItem) {
                if (trackList[j].id === currentDragItem.id) {
                    index = i;
                    currentDrageIndex = j;
                    data = DragItem;
                    DragItem.trackList[j].sxTrack.setStartTime(startTime);
                }
            }

        }
    }

    let id = uniqueId("swf");
    let sxTrack = null;
    sxTrack = currentDragItem.sxTrack.clone();

    let appendData = {
        ...data,
        id,
        type: currentDragItem.type,
        BoundingClientRect: null,
        currentTrack: false,
        isShowBottomLine: false,
        isShowTopLine: false,
        trackList: [
            {
                ...currentDragItem,
                id: uniqueId("fa"),
                pid: id,
                type: currentDragItem.type,
                startTime: startTime,
                duration: currentDragItem.duration,
                text: currentDragItem.text,
                rotation: 0,
            }
        ]
    };


    state.currentDragItem = null;

    if (data.trackList.length > 1) {
        //删除轨道
        let deleteArr = data.trackList.splice(currentDrageIndex, 1);
        let deleteItem = deleteArr[0];
        //创建组,创建轨道
        let newData = {
            type: deleteItem.type,
            duration: deleteItem.duration,
            text: deleteItem.text,
            effectPath: deleteItem.resourcesPath || "",
            startTime
        };

        let sxTrackGroup = editorManager.addGroupAtIndex(index);
        let textInfoObj = null;
        switch (newData.type) {
            case 1:
                //文字
                textInfoObj = currentDragItem.textInfoObj;
                break;

            case 2:
                //贴纸
                break;

            case 5:
                //画中画
                break;
            case 6:
                //音频
                break;
            default:
                sxTrack = null;
                break;
        }

        sxTrackGroup.addTrack(sxTrack, newData.startTime);
        let scale = null
        if (newData.type !== 6) {
            scale = sxTrack.getScale();
            scale = {
                mX: scale[0],
                mY: scale[1]
            };
        }


        appendData["textInfoObj"] = textInfoObj;
        appendData["sxTrackGroup"] = sxTrackGroup;
        appendData["trackList"][0].scale = scale;
        appendData["trackList"][0].sxTrack = sxTrack;
        return update(state, {
            groupList: {
                $splice: [[GroupIndex + 1, 0, appendData]]
            },
            allMediaBeforeDuration: {
                [appendData.trackList[0]['id']]: {
                    $set: state.allMediaBeforeDuration[deleteItem['id']]
                }
            }
        });

    } else {
        if (index === GroupIndex || (GroupIndex + 1) === index) {
            return state;
        } else {
            let newState = update(state, {
                groupList: {
                    $splice: [[GroupIndex + 1, 0, appendData]]
                },
                allMediaBeforeDuration: {
                    [appendData.trackList[0]['id']]: {
                        $set: state.allMediaBeforeDuration[currentDragItem['id']]
                    }
                }

            });
            if (index > GroupIndex) {
                index++;
            }

            return update(newState, {
                groupList: {
                    $splice: [[index, 1]]
                }
            });
        }
    }
}

const insertNewFilterEffectGroup = (state: IDefaultState, action) => {
    let {
        payload: {
            currentDragData,
            groupIndex,
            startTime,
            mainCompositeTrack
        }
    } = action;

    let {
        filter_effect_group
    } = state;

    let groupId = uniqueId("filter_track_group");

    let effectData = {
        ...currentDragData,
        id: uniqueId("filter_track"),
        pid: groupId,
        startTime: startTime,
    }

    let effectInfo = addEffectToMainTrack(mainCompositeTrack, effectData, effectData.type == 3)
    effectData["effectInfo"] = effectInfo;

    let appendData = {
        id: groupId,
        type: currentDragData.type,
        BoundingClientRect: null,
        currentTrack: false,
        isShowBottomLine: false,
        isShowTopLine: false,
        trackList: [
            effectData
        ]
    };

    let le = filter_effect_group.length;
    let currentDragIndex = -1;
    let index = -1;

    for (let i = 0; i < le; i++) {
        let DragItem = state.filter_effect_group[i];
        let le = DragItem.trackList.length;
        let trackList = DragItem.trackList;
        DragItem.isShowBottomLine = false;
        for (let j = 0; j < le; j++) {
            if (trackList[j] && currentDragData) {
                if (trackList[j].id === currentDragData.id) {
                    index = i;
                    currentDragIndex = j;
                }
            }

        }
    }

    let currentGroup = filter_effect_group[index];
    state.currentFilterEffectDragItem = null;

    if (currentGroup.trackList.length > 1) {
        currentGroup.trackList.splice(currentDragIndex, 1);
        return update(state, {
            filter_effect_group: {
                $splice: [[groupIndex + 1, 0, appendData]]
            }
        });
    } else {
        if (index === groupIndex || (groupIndex + 1) === index) {
            return state;
        } else {
            let newState = update(state, {
                filter_effect_group: {
                    $splice: [[groupIndex + 1, 0, appendData]]
                }
            });
            if (index > groupIndex) {
                index++;
            }
            return update(newState, {
                filter_effect_group: {
                    $splice: [[index, 1]]
                }
            });
        }
    }

}

const ChangeGroupToTopBoundary = (state: IDefaultState, action) => {
    let { payload: { startTime } } = action;
    let { editorManager } = state;
    let le = state.groupList.length;
    let currentDragItem = state.currentDragItem;
    let data = null;
    let index = null;
    let currentDrageIndex = null;
    for (let i = 0; i < le; i++) {
        let DragItem = state.groupList[i];
        let le = DragItem.trackList.length;
        let trackList = DragItem.trackList;
        for (let j = 0; j < le; j++) {
            if (trackList[j].id === currentDragItem.id) {
                index = i;
                currentDrageIndex = j;
                data = DragItem;
                trackList[j].startTime = startTime;
                DragItem.trackList[j].sxTrack.setStartTime(startTime);
            }
        }
    }

    state.currentDragItem = null;

    if (data.trackList.length > 1) {
        let deleteArr = data.trackList.splice(currentDrageIndex, 1),
            track = currentDragItem.sxTrack.clone(),
            deleteItem = deleteArr[0];

        editorManager.getGroup(deleteItem.sxTrack.getGroupId()).removeTrack(deleteItem.sxTrack.getTrackId());

        let newData = {
            type: deleteItem.type,
            duration: deleteItem.duration,
            text: deleteItem.text,
            effectPath: deleteItem.resourcesPath || "",
            rotation: deleteItem.rotation,
            startTime
        };

        let id = uniqueId("afa");
        let duration = newData.duration || 10;
        let textInfoObj = null;

        switch (newData.type) {
            case 1:
                //文字轨道
                textInfoObj = currentDragItem.textInfoObj;
                break;

            case 2:
                //贴纸轨道
                break;

            case 5:
                // 画中画
                break;
            case 6:
                // 音频
                break;
            default:
                track = null;
                break;
        }

        let trackGroup = editorManager.addGroupAtIndex(index);
        trackGroup.addTrack(track, newData.startTime);
        let scale = null
        if (newData.type !== 6) {
            scale = track.getScale();
            scale = {
                mX: scale[0],
                mY: scale[1],
            };
        }


        let appendData = {
            id,
            type: newData.type,
            BoundingClientRect: null,
            currentTrack: false,
            isShowBottomLine: false,
            isShowTopLine: false,
            sxTrackGroup: trackGroup,
            trackList: [
                {
                    id: uniqueId("gdr"),
                    pid: id,
                    type: newData.type,
                    startTime: newData.startTime,
                    duration,
                    text: newData.text,
                    scale,
                    sxTrack: track,
                    rotation: newData.rotation || 0,
                    resourcesPath: newData.effectPath || "",
                    textInfoObj,
                    shotUrl: deleteItem.shotUrl
                }
            ]
        };
        return update(state, {
            groupList: {
                $unshift: [appendData]
            },
            allMediaBeforeDuration: {
                [appendData.trackList[0]['id']]: {
                    $set: state.allMediaBeforeDuration[deleteItem['id']] || duration
                }
            }
        });
    }

    let newState = update(state, {
        groupList: {
            $splice: [[index, 1]]
        }

    });

    return update(newState, {
        groupList: {
            $unshift: [data]
        }
    });
}

const mergeProperty = (state: IDefaultState, action) => {
    let { payload: { data } } = action;
    return update(state, {
        $merge: data
    });
}

const ChangeProperty = (state: IDefaultState, action) => {
    let { propertyName, payload: { data } } = action;
    let { currentFilterEffectDragItem } = state;
    if (propertyName === "currentDragItem" && currentFilterEffectDragItem) {
        currentFilterEffectDragItem = null;
    }
    return update(state, {
        [propertyName]: { $set: data }
    });
}


const ChangeGroupItemProperty = (state: IDefaultState, action) => {
    let { index, propertyName, payload: { data } } = action;

    return update(state, {
        groupList: {
            [index]: {
                $set: {
                    ...state.groupList[index],
                    [propertyName]: data
                }
            }
        }
    });
}

const ChangeFilterEffectGroupItemProperty = (state: IDefaultState, action) => {
    let { index, propertyName, payload: { data } } = action;

    return update(state, {
        filter_effect_group: {
            [index]: {
                $set: {
                    ...state.filter_effect_group[index],
                    [propertyName]: data
                }
            }
        }
    });
}

const changeEditWindow = (state: IDefaultState, action) => {
    let { propertyName, payload: { data } } = action;
    return update(state, {
        editWindow: {
            [propertyName]: { $set: data }
        }
    });
}

const changeEditWindowData = (state: IDefaultState, action) => {
    let { payload: { data } } = action;

    let newData = {
        ...state.editWindow,
        ...data
    }

    return update(state, {
        editWindow: { $set: newData }
    });
}

const changTrackDragProps = (state: IDefaultState, action) => {
    let { payload: { data } } = action;

    let newData = {
        ...state.trackDrag,
        ...data
    }
    return update(state, {
        trackDrag: { $set: newData }
    });
}

const changeSticker = (state: IDefaultState, action) => {
    let { groupList, currentDragItem, editorManager } = state;
    let { payload: { data: { effectPath } } } = action;
    let newList = groupList.map((ele) => {
        if (ele.id === currentDragItem.pid) {
            let track = currentDragItem.sxTrack,
                sxTrackGroup = ele.sxTrackGroup,
                position = track.getPosition(),
                SXResourceType = window["SXResourceType"],
                SXResource = window["SXResource"],
                source = new SXResource(SXResourceType.kSticker, effectPath),
                sxTrack = editorManager.createStickerTrack(source, 1);

            position = {
                mX: position[0],
                mY: position[1]
            };

            editorManager.deleteTrack(track.getTrackId());
            sxTrackGroup.addTrack(sxTrack, currentDragItem.startTime);
            sxTrack.setDuration(currentDragItem.duration);
            sxTrack.setPosition(position.mX, position.mY);
            sxTrack.setScale(currentDragItem.scale.mX, currentDragItem.scale.mY);
            if (currentDragItem.trackAnimation) {
                delete currentDragItem.trackAnimation;
            }

            ele.trackList.map((track) => {
                if (track.id === currentDragItem.id) {
                    track.sxTrack = sxTrack;
                }
                return track;
            });
            currentDragItem.sxTrack = sxTrack;
        }
        return ele;
    });

    editorManager.draw(true, false, -1);
    return update(state, {
        groupList: { $set: newList }
    });
}


const deleteSource = (trackId, groupSourceList, state) => {
    let list = [];
    groupSourceList.map((source, index) => {
        if (source.trackId == trackId) {
            source.delegate.unused();
            source.delegate.release();
            groupSourceList.splice(index, 1);
        } else {
            list.push(source);
        }
    })

    update(state, {
        groupSourceList: { $set: list },
    })
}



const removeTrack = (state: IDefaultState, action) => {
    let { payload: { data } } = action;
    let { groupList, editorManager, groupSourceList, videoSubtitleList } = state;
    let isDeleteGroup = false;
    let index = -1;
    let subTitleDeleteItem = null

    let newList = groupList.map((group, groupIndex) => {

        if (group.id === data.pid) {
            // delete track 
            group.trackList.map((track, trackIndex) => {
                if (track.id === data.id) {
                    console.log("delete track", track, groupSourceList);
                    editorManager.deleteTrack(track.sxTrack.getTrackId());

                    // @TODO 检查资源被使用了几次， 等于 0 时可删除
                    deleteSource(track.trackId, groupSourceList, state);
                    groupList[groupIndex].trackList.splice(trackIndex, 1);
                    subTitleDeleteItem = track

                }
                return null;
            });


            // delete group
            if (group.trackList.length < 1) {
                editorManager.deleteGroup(group.sxTrackGroup.getGroupId());
                isDeleteGroup = true;
                index = groupIndex;
            }

        }
        return group;
    });

    if (isDeleteGroup) {
        newList.splice(index, 1);
    }
    //文字轨道删除时，同步删除字幕列表
    if (subTitleDeleteItem) {
        videoSubtitleList.forEach((v, i) => {
            v.forEach((m, index) => {
                if (subTitleDeleteItem.id === m.trackId_text) {
                    v.splice(index, 1)
                }
            })
        })
    }
    editorManager.draw(true, false, -1);

    console.log("after removed", newList);
    return update(state, {
        groupList: { $set: newList },
        videoSubtitleList: { $set: Object.assign([], videoSubtitleList) }
    });
}

const removeFilterEffectTrack = (state: IDefaultState, action) => {
    let { payload: { data } } = action,
        { filter_effect_group, editorManager } = state,
        isDeleteGroup = false,
        index = -1,
        newList = filter_effect_group.map((group, groupIndex) => {
            if (group.id === data.pid) {
                if (group.trackList.length === 1) {
                    isDeleteGroup = true;
                    index = groupIndex;
                } else {
                    group.trackList.map((track, trackIndex) => {
                        if (track.id === data.id) {
                            filter_effect_group[groupIndex].trackList.splice(trackIndex, 1);
                        }
                        return null;
                    });
                }

            }
            return group;
        });

    if (data.type === 3) {
        let { track, effectId } = data.effectInfo;
        track.removeFilter(effectId);
    } else if (data.type === 4) {
        let { track, effectId } = data.effectInfo;
        track.removeVideoEffect(effectId);
    }

    if (isDeleteGroup) {
        newList.splice(index, 1);
    }

    editorManager.draw(true, false, -1);

    console.log("Remove Effect Track", data, newList);
    return update(state, {
        filter_effect_group: { $set: newList }
    });
}

const changeTextBubble = (state: IDefaultState, action) => {
    let { payload: { path } } = action,
        { editorManager, currentDragItem: { videoTrack, sxTrack } } = state,
        SXtrack = videoTrack || sxTrack,
        SXResourceType = window["SXResourceType"],
        SXResource = window["SXResource"];

    if (SXtrack) {
        const source = new SXResource(SXResourceType.kTextBubble, path);
        SXtrack.setBubble(source);
    }

    editorManager.draw(true, false, -1);

    return state;
}

const clearLine = (state: IDefaultState) => {
    let { groupList } = state;
    let newList = groupList.map(ele => {
        if (ele.isShowBottomLine) {
            ele.isShowBottomLine = false;
        }

        if (ele.currentTrack) {
            ele.currentTrack = false;
        }

        if (ele.isShowTopLine) {
            ele.isShowTopLine = false;
        }

        return ele;
    });


    return update(state, {
        groupList: { $set: newList }
    });
}

const clearFilterEffectLine = (state: IDefaultState) => {
    let { filter_effect_group } = state;
    let newList = filter_effect_group.map(ele => {
        if (ele.isShowBottomLine) {
            ele.isShowBottomLine = false;
        }

        if (ele.currentTrack) {
            ele.currentTrack = false;
        }

        if (ele.isShowTopLine) {
            ele.isShowTopLine = false;
        }

        return ele;
    });


    return update(state, {
        filter_effect_group: { $set: newList }
    });
}

const addPip_Sticker_Text_Group = (state: IDefaultState, action) => {
    let { editorManager, groupList, canvasWidth, canvasHeight } = state,
        { index, payload: { data } } = action,
        id = uniqueId("track-group"),
        sxTrackGroup = editorManager.addGroupAtIndex(index),
        duration = data.duration || 10;
    let {
        sxTrack, textInfoObj, groupSource
    } = data.track;



    sxTrackGroup.addTrack(sxTrack, data.startTime);
    sxTrack.setDuration(duration);

    if (data.type !== 6) {
        // let MAX_PIX = Math.max(sxTrack.getHeight(), sxTrack.getWidth())
        // let LONG_SIZE = Math.max(canvasWidth, canvasHeight);
        sxTrack.setPosition(Math.round(canvasWidth / 2), Math.round(canvasHeight / 2));
        if (data.type === 5) {
            let widthRatio = canvasWidth / sxTrack.getWidth();
            let heightRatio = canvasHeight / sxTrack.getHeight();
            let ratio = Math.min(widthRatio, heightRatio);
            sxTrack.setScale(ratio * 0.8, ratio * 0.8)

        } else {
            sxTrack.setScale(0.4, 0.4)

        }
    }

    let appendData = {
        id,
        type: data.type,
        BoundingClientRect: null,
        currentTrack: false,
        isShowBottomLine: false,
        isShowTopLine: false,
        sxTrackGroup,
        trackList: [
            {
                id: uniqueId("track"),
                pid: id,
                type: data.type,
                startTime: data.startTime,
                duration,
                text: data.text,
                scale: data.type !== 6 ? sxTrack.getScale() : null,
                sxTrack,
                rotation: 0,
                shotUrl: data.shotUrl,

            }
        ]
    };
    if (data.currentDrag.type === 5 && Number(data.currentDrag.video_fps) === 0) {
        appendData.trackList[0].shotUrl = data.currentDrag.url
    }

    let newGroupList = update(groupList, {
        $splice: [[index + 1, 0, appendData]]
    });
    // allMediaBeforeDuration:{
    //     [appendData.trackList[0]['id']]:{
    //         $set:state.allMediaBeforeDuration[deleteItem['id']] || duration
    //     }
    // }
    return update(state, {
        groupList: { $set: newGroupList },
        groupSourceList: { $push: [groupSource] },
        allMediaBeforeDuration: {
            [appendData.trackList[0]['id']]: {
                $set: duration
            }
        }
    });
}

const insert_Filter_Effect_Group = (state: IDefaultState, action) => {

    console.log("insert filter group", action)
    let { payload: { data, mainCompositeTrack }, index } = action,
        { editorManager } = state,
        effectInfo = null;
    let { mainTrackGroup, filter_effect_group } = state;
    let id = uniqueId("filter_or_text");

    switch (data.type) {
        case 3:
            effectInfo = addEffectToMainTrack(mainCompositeTrack, data, true);
            console.log("遍历添加滤镜!");
            break;

        case 4:
            effectInfo = addEffectToMainTrack(mainCompositeTrack, data, false);
            console.log("遍历添加视频特效!");
            break;
    }

    editorManager.draw(true, false, -1);

    let duration = data.duration || 4,
        appendData = {
            id,
            type: data.type,
            BoundingClientRect: null,
            currentTrack: false,
            isShowBottomLine: false,
            isShowTopLine: false,
            trackList: [
                {
                    id: uniqueId("gdr"),
                    pid: id,
                    type: data.type,
                    startTime: data.startTime,
                    effectPath: data.effectPath,
                    text: data.text,
                    effectInfo: effectInfo,
                    duration,
                }
            ]
        };



    let newGroupList = update(filter_effect_group, {
        $splice: [[index + 1, 0, appendData]]
    });

    console.log("insert_Filter_Effect_Group", newGroupList);
    let isShow = true;
    return update(state, {
        filter_effect_group: { $set: newGroupList }
    });
}

//轨道位置调整时, 更新sdk中轨道位置,与界面轨道排序保持一致
const correctionGroupZindexFromSDK = (state: IDefaultState = defaultState) => {
    let { editorManager, groupList } = state;
    groupList.reverse().map((value, index) => {
        let { sxTrackGroup } = value;
        editorManager.moveGroupTo(sxTrackGroup.getGroupId(), index + 1);
        return null;
    });
    groupList.reverse();

    return state;
}

//轨道位置调整时, 更新sdk中轨道起始位置,与界面轨道起始位置保持一致
const correctionGroupStartTimeFromSDK = (state: IDefaultState = defaultState) => {
    let { editorManager, groupList } = state;
    groupList.map((value) => {
        let { sxTrackGroup, trackList } = value;
        trackList.map((track) => {
            let id = track.sxTrack.getTrackId();
            sxTrackGroup.moveTrackTo(id, track.startTime);
            track.sxTrack.setDuration(track.duration);
            return null;
        });
        return null;
    });
    editorManager.draw(true, false, -1);
    return state;
}

const appendTrackToFilterEffectGroup = (state: IDefaultState, action) => {

    let {
        payload: {
            groupIndex, startTime, currentDragItem: currentDragData, mainCompositeTrack
        }
    } = action;

    let {
        filter_effect_group,
        mainTrackGroup
    } = state;

    let le = filter_effect_group.length;
    let currentDragIndex = -1;
    let index = -1;

    for (let i = 0; i < le; i++) {
        let DragItem = filter_effect_group[i];
        let le = DragItem.trackList.length;
        let trackList = DragItem.trackList;
        for (let j = 0; j < le; j++) {
            if (trackList[j] && currentDragData) {
                if (trackList[j].id === currentDragData.id) {
                    index = i;
                    currentDragIndex = j;
                }
            }
        }
    }

    state.currentFilterEffectDragItem = null;
    let deleteGroup = filter_effect_group[index];
    let currentGroup = filter_effect_group[groupIndex];

    let appendData = {
        ...currentDragData,
        id: uniqueId("filter_effect_track_"),
        pid: currentGroup.id,
        startTime: startTime,
    };
    // 重新计算特效的时间
    let effectInfo = addEffectToMainTrack(mainCompositeTrack, appendData, currentDragData.type == 3)
    appendData["effectInfo"] = effectInfo;;

    console.log("append effect ", appendData, effectInfo)

    let newList = update(filter_effect_group, {
        [groupIndex]: {
            trackList: {
                $push: [appendData]
            }
        }
    });

    if (deleteGroup.trackList.length > 1) {
        newList[index].trackList.splice(currentDragIndex, 1);
    } else {
        newList.splice(index, 1);
    }
    console.log("appendTrackToFilterEffectGroup", newList);
    let show = true;
    return update(state, {
        isMoveTimeLine: { $set: show },
        filter_effect_group: { $set: newList }
    });
}

const correctStartTime = (state: IDefaultState, action) => {
    let { groupList, filter_effect_group, isFilterGroup } = state,
        currentGroupList = isFilterGroup ? filter_effect_group : groupList,
        { payload: { groupIndex } } = action,
        trackList = currentGroupList[groupIndex].trackList,
        len = trackList.length,
        attributeName = isFilterGroup ? "filter_effect_group" : "groupList";

    let newTrackList = trackList.map((currentTrack: any, index: number) => {
        let minBoundary = currentTrack.startTime,
            maxBoundary = currentTrack.startTime + currentTrack.duration;
        for (let index = 0; index < len; index++) {
            const track = trackList[index],
                startTime = track.startTime;
            // totalTime = startTime + track.duration;
            if (
                (
                    startTime >= minBoundary
                    &&
                    startTime <= maxBoundary
                )
                // ||
                // (
                //  还有条件
                // )
            ) {
                console.log("碰撞");
                // console.log(index, currentTrack);

            }
        }
        // currentTrack.startTime = 10 * index;
        return currentTrack;
    });


    return update(state, {
        [attributeName]: {
            [groupIndex]: {
                trackList: {
                    $set: newTrackList
                }
            }
        }
    });
}

const segmentationTrack = (state: IDefaultState,) => {
    let {
        currentDragItem, currentTime, filter_effect_group, isFilterGroup, groupList
    } = state,
        windowEditManager = window["SXEditManager"],
        currentGroupList = isFilterGroup ? filter_effect_group : groupList,
        attributeName = isFilterGroup ? "filter_effect_group" : "groupList",
        len = currentGroupList.length;

    let currentGroupIndex = -1,
        currentTrackIndex = -1;
    for (let i = 0; i < len; i++) {
        const group = currentGroupList[i];
        if (currentDragItem.pid === group.id) {

            // eslint-disable-next-line no-loop-func
            group.trackList.map((track: any, index: number) => {
                if (track.id === currentDragItem.id) {
                    currentGroupIndex = i;
                    currentTrackIndex = index;
                }
                return track;
            });
        }
    }

    /**
     * currentTrackIndex 当前分割的第几个轨道
     * currentGroupIndex  轨道组索引
     * currentGroupList  所有的轨道
     * currentDragItem  当前点击的轨道
     * **/

    let currentTrackList = (currentGroupList[currentGroupIndex].trackList),
        currentGroup = currentGroupList[currentGroupIndex],
        currentTrack = currentTrackList[currentTrackIndex],
        currentTrackDuration = currentTime - currentTrack.startTime,
        newSxTrack = currentGroup.sxTrackGroup.splitTrack(currentDragItem.sxTrack.getTrackId(), currentTrackDuration),
        offsetTime = newSxTrack.getOffsetTime(),
        newDuration = newSxTrack.getDuration();
    console.log(state.allMediaBeforeDuration, currentTrack)
    let beforeDuration = state.allMediaBeforeDuration[currentTrack.id].duration ? state.allMediaBeforeDuration[currentTrack.id].duration : state.allMediaBeforeDuration[currentTrack.id]
    //拆分时需要存两个字段，分别是当前素材真实的开始时间和视频的原时长
    let newTrackDurationiInfo = {
        beginTime: offsetTime,
        duration: beforeDuration
    }
    let beforeTrackTime = {
        endTime: offsetTime,
        duration: currentDragItem['duration']
    }

    /**
     *  轨道类型
     *  1 ===> 文字轨道
     *  2 ===> 贴纸轨道
     *  3 ===> 滤镜轨道
     *  4 ===> 特效轨道
     *  5 ===> 画中画轨道
     *  6 ===> 音频轨道
     */
    switch (currentDragItem.type) {
        case 1:
            newSxTrack = windowEditManager.toTextTrack(newSxTrack);
            break;

        case 2:
            newSxTrack = windowEditManager.toStickerTrack(newSxTrack);
            break;

        default:
            newSxTrack = windowEditManager.toMediaTrack(newSxTrack);
            break;
    }

    let appendData = {
        ...currentDragItem,
        trackId: newSxTrack.getTrackId(),
        id: uniqueId("gdr"),
        startTime: currentTime,
        offsetTime: offsetTime,
        duration: newDuration,
        sxTrack: newSxTrack,
    };


    // 增加引用
    let videoDelegate = currentDragItem.videoDelegate;
    if (videoDelegate) {
        videoDelegate.used();
        appendData["videoDelegate"] = videoDelegate;
    }



    currentTrack.duration = currentTrackDuration;
    currentTrack.id = uniqueId("gdr");
    currentTrackList.push(appendData);

    let toUpdate = null;

    if (videoDelegate) {
        let groupSource = {
            trackId: newSxTrack.getTrackId(),
            delegate: videoDelegate
        }
        toUpdate = {
            [attributeName]: {
                [currentGroupIndex]: {
                    trackList: {
                        $set: currentTrackList
                    }
                }
            },
            groupSourceList: {
                $push: [groupSource],
            },
            allMediaBeforeDuration: {
                [appendData['id']]: {
                    $set: newTrackDurationiInfo
                },
                [currentTrack['id']]: {
                    $set: beforeTrackTime
                },
            }
        }
    } else {
        toUpdate = {
            [attributeName]: {
                [currentGroupIndex]: {
                    trackList: {
                        $set: currentTrackList
                    }
                }
            },
            allMediaBeforeDuration: {
                [appendData['id']]: {
                    $set: newTrackDurationiInfo
                },
                [currentTrack['id']]: {
                    $set: beforeTrackTime
                },
            }

        }

    }

    return update(state, toUpdate);

}

const copyTrack = (state: IDefaultState) => {
    let { editorManager, groupList, currentDragItem } = state,
        index = groupList.length,
        windowEditManager = window["SXEditManager"];

    for (let i = 0; i < index; i++) {
        const group = groupList[i];
        const trackList = group.trackList;
        const trackListLen = trackList.length;
        for (let j = 0; j < trackListLen; j++) {
            const track = trackList[j];
            if (currentDragItem.id === track.id) {
                currentDragItem = track;
                break;
            }
        }
    }

    if (index !== 0) {
        index++;
    } else {
        index = 1;
    }

    let sxTrackGroup = editorManager.addGroupAtIndex(10),
        id = uniqueId("track-group"),
        sxTrack = editorManager.cloneTrack(currentDragItem.sxTrack);



    // console.log(currentDragItem.sxTrack);

    /**
     *  轨道类型
     *  1 ===> 文字轨道
     *  2 ===> 贴纸轨道
     *  3 ===> 滤镜轨道
     *  4 ===> 特效轨道
     *  5 ===> 画中画轨道
     *  6 ===> 音频轨道
     */
    switch (currentDragItem.type) {
        case 1:
            sxTrack = windowEditManager.toTextTrack(sxTrack);
            break;

        case 2:
            sxTrack = windowEditManager.toStickerTrack(sxTrack);
            break;

        default:
            sxTrack = windowEditManager.toMediaTrack(sxTrack);
            break;
    }




    sxTrackGroup.addTrack(sxTrack, currentDragItem.startTime);


    let trackData = {
        ...currentDragItem,
        id: uniqueId("gdr"),
        pid: id,
        sxTrack: sxTrack,
        trackId: sxTrack.getTrackId(),
    }
    // 增加引用
    let videoDelegate = currentDragItem.videoDelegate;
    if (videoDelegate) {
        videoDelegate.used();
        trackData["videoDelegate"] = videoDelegate;
    }


    let appendData = {
        id: id,
        type: currentDragItem.type,
        BoundingClientRect: null,
        currentTrack: false,
        isShowBottomLine: false,
        isShowTopLine: false,
        sxTrackGroup: sxTrackGroup,
        trackList: [
            trackData
        ]
    };


    // 添加到 groupsource
    let newState = state;
    if (trackData.videoDelegate) {
        let groupSource = {
            trackId: sxTrack.getTrackId(),
            delegate: videoDelegate
        }
        newState = update(state, {
            groupSourceList: {
                $push: [groupSource],
            }
        })
    }


    return update(newState, {
        groupList: {
            $unshift: [appendData]
        }
    });
}

export default (state: IDefaultState = defaultState, action) => {

    switch (action.type) {
        case actionTypes.SEGMENTATION_TRACK:
            return segmentationTrack(state);

        case actionTypes.COPY_TRACK:
            return copyTrack(state);

        case actionTypes.CORRECT_START_TIME:
            return correctStartTime(state, action);

        case actionTypes.APPEND_TRACK_TO_FILTER_EFFECT_GROUP:
            return appendTrackToFilterEffectGroup(state, action);

        case actionTypes.INSERT_NEW_FILTER_EFFECT_GROUP:
            return insertNewFilterEffectGroup(state, action);

        case actionTypes.REMOVE_FILTER_EFFECT_TRACK:
            return removeFilterEffectTrack(state, action);

        case actionTypes.CORRECTION_GROUP_START_TIME_FROM_SDK:
            return correctionGroupStartTimeFromSDK(state);

        case actionTypes.CORRECTION_GROUP_ZINDEX_FROM_SDK:
            return correctionGroupZindexFromSDK(state);

        case actionTypes.CHANGE_FILTER_EFFECT_DRAG_START_TIME:
            return ChangeFilterEffectDragStartTime(state, action);

        case actionTypes.CHANGE_FILTER_EFFECT_GROUP_ITEM_PROPERTY:
            return ChangeFilterEffectGroupItemProperty(state, action);

        case actionTypes.CHANGE_FILTER_EFFECT:
            return ChangeFilterEffect(state, action);

        case actionTypes.INSERT_FILTER_EFFECT_GROUP:
            return insert_Filter_Effect_Group(state, action);

        case actionTypes.INSERT_FILTER_EFFECT_TRACK_TO_GROUP:
            return insert_Filter_Effect_TrackToGroup(state, action);

        case actionTypes.ADD_FILTER_EFFECT_GROUP:
            return Add_Filter_Effect_Group(state, action);

        case actionTypes.ADD_PIP_STICKER_TEXT_GROUP:
            return addPip_Sticker_Text_Group(state, action);

        case actionTypes.CLEAR_LINE:
            return clearLine(state);

        case actionTypes.CLEAR_FILTER_EFFECT_LINE:
            return clearFilterEffectLine(state);

        case actionTypes.CHANGE_TEXT_BUBBLE:
            return changeTextBubble(state, action);

        case actionTypes.REMOVE_TRACK:
            return removeTrack(state, action);

        case actionTypes.CHANGE_STICKER:
            return changeSticker(state, action);

        case actionTypes.CHANGE_TRACK_DRAG_PROPS:
            return changTrackDragProps(state, action);

        case actionTypes.CHANGE_EDIT_WINDOW:
            return changeEditWindow(state, action);

        case actionTypes.CHANGE_EDIT_WINDOW_DATA:
            return changeEditWindowData(state, action);

        case actionTypes.INSERTION_NEW_GROUP:
            return insertionNewGroup(state, action);

        case actionTypes.INSERTION_NEW_FILTER_EFFECT_GROUP:
            return insertionNewFilterEffectGroup(state, action);

        case actionTypes.CHANGE:
            return Change(state, action);

        case actionTypes.CHANGE_CURRENT_TRACK:
            return ChangeCurrentTrack(state, action);

        case actionTypes.CHANGE_FILTER_EFFECT_CURRENT_TRACK:
            return ChangeFilterEffectCurrentTrack(state, action);

        case actionTypes.ADD_GROUP:
            return AddGroup(state, action);

        case actionTypes.CHANGE_CURRENT_DRAG_ITEM:
            return ChangeCurrentDragItem(state, action);

        case actionTypes.UPDATE:
            return Update(state, action);

        case actionTypes.CHANGE_IS_MOVE_TIME_LINE_STATUS:
            return ChangeIsMoveTimeLineStatus(state, action);

        case actionTypes.CHANGE_DRAG_START_TIME:
            return ChangeDragStartTime(state, action);

        case actionTypes.APPEND_TRACK_TO_GROUP:
            return AppendTrackToGroup(state, action);

        case actionTypes.CHANGE_MAX_DURATION:
            return ChangeMaxDuration(state);

        case actionTypes.CHANGE_CURRENT_TIME:
            return ChangeCurrentTime(state, action);

        case actionTypes.CHANGE_FILTER_EFFECT_DRAG_DURATION:
            return ChangeFilterEffectDragDuration(state, action);

        case actionTypes.CHANGE_DRAG_DURATION:
            return ChangeDragDuration(state, action);

        case actionTypes.CHANGE_GROUP_TO_BOTTOM_BOUNDARY:
            return ChangeGroupToBottomboundary(state, action);

        case actionTypes.MERGE_TRACK_MANAGER_PROPERTY:
            return mergeProperty(state, action);

        case actionTypes.CHANGE_TRACK_MANAGER_PROPERTY:
            return ChangeProperty(state, action);

        case actionTypes.CHANGE_GROUP_ITEM_PROPERTY:
            return ChangeGroupItemProperty(state, action);

        case actionTypes.CHANGE_GROUP_TO_TOP_BOUNDARY:
            return ChangeGroupToTopBoundary(state, action);

        case actionTypes.INSERT_NEW_TRACK_TO_GROUP:
            return insertNewTrackToGroup(state, action);

        case actionTypes.UPDATE_CURRENT_DRAG_ITEM:
            return updateCurrentDragItem(state, action);

        case 'changeInputValue':
            return changeInputValue(state, action);

        case 'deleteSubtitle':
            return deleteSubtitle(state, action);

        case 'changeVideoSubtitleText':
            return changeVideoSubtitleText(state, action);
        case actionTypes.CHANGE_FILTER_EFFECT_CURRENT_DRAG_ITEM:
            return ChangeFilterEffectCurrentDragItem(state, action);



        default:
            return state;
    }
}

